// import Benefits from './data'
import Hero from './Hero'
import PricingPlans from './PricingPlans'
import { benefits } from './data'
import FAQs from './FAQs'
import CTA from './CTA'
// import { Footer } from '@/components'
import Benefits from './Benefits'
import LayoutsNavbar from '../../components/LayoutsNavbar/LayoutsNavbar'
import Footer1 from '../../components/common/Footer1'
import { useLayoutEffect } from 'react'
import ScrollToTop from '../../components/scroll-to-top/ScrollToTop'

const Pricing = () => {
	console.log(benefits ,"-----------")
	useLayoutEffect(()=>{
		window.scrollTo(0,0)
	},[])
	return (
		<>
			<div>
			 <ScrollToTop />
				<LayoutsNavbar/>
				
				{/* <Hero /> */}

				<PricingPlans />

				{/* <Benefits benefits={benefits} /> */}
				{/* <h1>Hello</h1> */}
				{/* <FAQs /> */}

				{/* <CTA /> */}
            {/* <Footer1/> */}

				{/* <Footer /> */}
			</div>
		</>
	)
}

export default Pricing
